import { SxProps, Theme } from '@mui/material/styles';

export const exploreCardStyles = {
  card: {
    display: 'flex',
    position: 'relative',
    width: '290px',
    height: '189px',
    borderRadius: '16px',
    overflow: 'hidden',
    flexShrink: 0,
    textDecoration: 'none',
  } as SxProps<Theme>,

  image: {
    position: 'absolute',
    inset: 0,
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    borderRadius: '16px',
    backgroundColor: 'neutral1.medium',
  } as SxProps<Theme>,

  overlay: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    padding: '12px',
    background: 'linear-gradient(to bottom, transparent, rgba(0, 0, 0, 0.9))',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    gap: '20px',
  } as SxProps<Theme>,

  content: {
    flex: 1,
    minWidth: 0,
  } as SxProps<Theme>,

  title: {
    fontFamily: '"Work Sans", sans-serif',
    fontWeight: 500,
    fontSize: '1.25rem',
    lineHeight: '1.75rem',
    letterSpacing: '-0.5px',
    display: 'block',
    color: 'common.white',
  } as SxProps<Theme>,

  arrowButton: {
    flexShrink: 0,
    width: '32px',
    height: '32px',
    borderRadius: '16px',
    padding: '6px',
    backgroundColor: 'rgba(243, 244, 245, 0.9)',
    '&:hover': {
      backgroundColor: 'rgba(243, 244, 245, 1)',
    },
  } as SxProps<Theme>,

  arrowIcon: {
    color: 'neutral1.darkest',
  } as SxProps<Theme>,
};